import axios, { AxiosInstance } from "axios";
import { log } from "src/utils/logger";

export const API_URL = import.meta.env.VITE_VUMI_API_URL;

export const apiClient: AxiosInstance = axios.create({
	baseURL: API_URL,
	headers: {
		"Content-Type": "application/json",
		"Access-Control-Allow-Origin": "*"
	}
});

apiClient.interceptors.request.use((request) => {
	log(`Start request ${request.url}`);
	return request;
});

export const setHeaderToken = (token: string) => {
	apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const removeHeaderToken = () => {
	delete apiClient.defaults.headers.common.Authorization;
};
